import * as serviceWorker from './base/serviceWorker';
import './instrument';

import { createRoot } from 'react-dom/client';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';
import AppContainer from './base/components/AppContainer';
import { persistor, store } from './base/redux/store';
import { config } from './config';
import { insertHeadLinks } from './insertHeadLinks';

// Stylesheets
import './base/assets/scss/libs.scss';
import { IS_PRODUCTION_ENV } from './base/Constants';
import { getCachedAvailData } from './base/redux/data/cachedAvail/actions';
import { appInit, getInitData } from './base/redux/init/actions';

if (IS_PRODUCTION_ENV) {
  config['google.gtm']?.length > 0 && TagManager.initialize({ gtmId: config['google.gtm'] });
  config['google.tag']?.length > 0 && ReactGA.initialize(config['google.tag']);
}

insertHeadLinks();

// Call initial api's as soon as possible
appInit(store.dispatch);
getInitData(store.dispatch);
getCachedAvailData(store.dispatch);

const root = createRoot(document.getElementById('root'));
root.render(<AppContainer store={store} persistor={persistor} />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
